// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exerciseImage {
    max-width: 150px;
    
    input {
        border-radius: 8px;
        padding: 6px 8px;
        box-sizing: border-box;
        -webkit-box-sizing: border-box; 
        -moz-box-sizing: border-box;
        border-style: solid;
        border-color: #B2B2B2;
        border-width: 1px;
        margin-top: 6px;
        width: 150px;
    }
    
    input:active {
        border-color: #B2B2B2;
    }
    
    img {
        width: 150px;
        height: calc(150px / (16 / 10));
        object-fit: contain;
        background-color: #CCC;
        border-radius: 6px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/CreateExercise/components/ExerciseImage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;;IAEhB;QACI,kBAAkB;QAClB,gBAAgB;QAChB,sBAAsB;QACtB,8BAA8B;QAC9B,2BAA2B;QAC3B,mBAAmB;QACnB,qBAAqB;QACrB,iBAAiB;QACjB,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,YAAY;QACZ,+BAA+B;QAC/B,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;IACtB;AACJ","sourcesContent":[".exerciseImage {\n    max-width: 150px;\n    \n    input {\n        border-radius: 8px;\n        padding: 6px 8px;\n        box-sizing: border-box;\n        -webkit-box-sizing: border-box; \n        -moz-box-sizing: border-box;\n        border-style: solid;\n        border-color: #B2B2B2;\n        border-width: 1px;\n        margin-top: 6px;\n        width: 150px;\n    }\n    \n    input:active {\n        border-color: #B2B2B2;\n    }\n    \n    img {\n        width: 150px;\n        height: calc(150px / (16 / 10));\n        object-fit: contain;\n        background-color: #CCC;\n        border-radius: 6px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
